import React, { useEffect } from "react";
import DatePicker, { ReactDatePickerProps } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./customDatePicker.css";
import CustomInput from "./CustomInput/CustomInput";
import CustomHeader from "./CustomHeader/CustomHeader";
import { TextFieldProps, useTheme } from "@material-ui/core";

export interface DPDatePickerProps {
  onDatePickerValueClear?: () => void;
  textFieldProps?: TextFieldProps;
}

const DPDatePicker = ({
  onDatePickerValueClear,
  textFieldProps,
  ...rest
}: DPDatePickerProps & ReactDatePickerProps) => {
  const theme = useTheme();

  // XXX: Hacky way to set different bg color on day select/hover in customDatePicker.css
  useEffect(() => {
    const root = document.querySelector(":root") as HTMLElement;
    root.style.setProperty(
      "--selectedDateColor",
      theme.palette.secondary.main
    );
  }, [theme]);



  return (
    <DatePicker
      renderCustomHeader={(props) => <CustomHeader {...props} minDate={rest.minDate as Date} maxDate={rest.maxDate as Date} />}
      customInput={(
        <CustomInput
          clearSelectedRange={onDatePickerValueClear}
          {...textFieldProps}
        />
      )}
      showPopperArrow={false}
      {...rest}
    />
  );
};


export default DPDatePicker;
